import React, {useEffect} from 'react';
import Footer from './Footer';
import MainHeader from './MainHeader';
import MobileMenu from './MobileMenu';
import PreLoader from './PreLoader';
import ScrollToTopButton from './ScrollToTopButton';
import SearchPopup from './SearchPopup';
import Subscribe from './Subscribe';

const DoctorProfile = () => {

    useEffect(() => {
        const form = document.getElementById('myForm') as HTMLFormElement;;
        if (form) {
          const handleSubmit = (event:any) => {
            event.preventDefault();
            
            // Get the form data
            const formData = new FormData(form);
            
            // Get the values from form data
            const name = formData.get('name');
            const email = formData.get('email');
            const phone = formData.get('phone');
            const message = formData.get('message');
            
            // Construct the email subject and body
            const subject = 'Contact Form Submission';
            const body = `Name: ${name}\nEmail: ${email}\nPhone: ${phone}\n\nMessage: ${message}`;
            
            // Create the mailto URL with the email subject and body
            const mailtoURL = `mailto:reddyg.spurthi@gmail.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
            
            // Open the user's email client with the pre-filled message
            window.location.href = mailtoURL;
          };
    
          form.addEventListener('submit', handleSubmit);
    
          return () => {
            form.removeEventListener('submit', handleSubmit);
          };
        }
      }, []);

      const handleDownload = () => {
        const downloadLink = document.createElement('a');
        downloadLink.href = 'assets/images/team/Spurthi_card.jpg';
        downloadLink.download = 'Dr_Spurthi_Visiting_Card.jpg';
        downloadLink.click();
      };

  return (
    <div className="App doctorProfile">
      <div className="boxed_wrapper">
        {/* <PreLoader /> */}
        <SearchPopup />
        <MainHeader />
        <MobileMenu />
      
        <section className="page-title">
            <div className="bg-layer" style={{backgroundImage: `url(assets/images/background/page-title.jpg)`}}></div>
            <div className="auto-container">
                <div className="content-box">
                    <h1>Doctor Profile</h1>
                    <ul className="bread-crumb clearfix">
                        <li><a href="/">Home</a></li>
                        <li>Doctor Profile</li>
                    </ul>
                </div>
            </div>
        </section>
        
        <section className="team-details p_relative">
            <div className="auto-container">
                <div className="row clearfix">
                    {/* <div className="col-lg-5 col-md-12 col-sm-12 image-column">
                        <figure className="image-box spurthi-img"><img src="assets/images/team/team-15.png" alt="" /></figure>
                    </div> */}
                    {/* <div className="col-lg-5 col-md-12 col-sm-12 image-column">
                        <div className="image_block_one">
                            <div className="image-box mr_30 pr_130 pb_100">
                                <div className="shape" style={{backgroundImage: `url('assets/images/shape/shape-1.png')`}}></div>
                                <figure className="image"><img src="assets/images/team/team-15.png" alt="" /></figure>
                                <div className="text p_absolute r_0 b_0">
                                    <h2>13+</h2>
                                    <h4>Years of Experience</h4>
                                </div>
                            </div>
                        </div>
                    </div> */}
                    <div className="col-lg-6 col-md-12 col-sm-12 image-column">
                        <div className="image_block_one">
                            <div className="image-box mr_30 pr_130 pb_100">
                                <div className="shape" style={{backgroundImage: `url('assets/images/shape/shape-1.png')`}}></div>
                                <figure className="image"><img src="assets/images/team/Sunshine_eye_care_25_solo_chair_new.jpeg" alt="" /></figure>
                                <div className="text p_absolute r_0 b_0">
                                    <h2>13+</h2>
                                    <h4>Years of Experience</h4>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-12 col-md-12 col-sm-12 column mt_50 mb_50">
                            <div className="message-btn">
                                <button className="theme-btn btn-one" onClick={handleDownload}>Download Business Card</button>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-12 col-sm-12 content-column doctor-details">
                        <div className="team-details-content">
                            <div className="team-info">
                                <h2>Dr. Spurthi Reddy K</h2>
                                <div className="category"><a className="designation">Phaco Refractive Surgeon, Paediatric Ophthalmology, Squint and Neuroophthalmology</a></div>
                                <p>Dr. K Spurthi Reddy is a highly accomplished medical professional with a strong background in Ophthalmology. <br/>
                                 With impressive credentials such as a DO, DNB, and FICO, Dr. Reddy's expertise is widely recognized. Having earned University Gold medals in ENT (2007) and Dip.Ophthalmology (2014), she has demonstrated exceptional academic prowess. <br/> 
                                 Dr. Reddy further honed her skills through a post-graduation program at the prestigious Aravind Eye Hospital in Pondicherry. Her dedication and commitment to excellence were acknowledged when she received the Best Physical poster award at the Uvea-AIOC 2017 event in Jaipur.  <br/>
                                 As a finalist of the Allergan Erudio quiz, Dr. Reddy showcased her knowledge and expertise in a competitive environment. She has also made significant contributions through multiple presentations at various levels, showcasing her passion for sharing knowledge and advancements in her field. <br/>
                                  Dr. K Spurthi Reddy is undoubtedly a valuable asset to the medical community.</p>
                                <ul className="list clearfix">
                                    <li><span>Occupation:</span>Ophthalmologist</li>
                                    <li><span>Experience:</span>13+ Years</li>
                                    <li><span>Skills:</span>Working with both children and adults</li>
                                    <li><span>Certificates:</span>Best Physical poster award</li>
                                    <li><span>Education:</span>DO, DNB, FICO</li>
                                    <li><span>Location:</span><a href="https://maps.app.goo.gl/Coc7TBGjEj715mDs6" target="_blank" rel="noopener noreferrer">D.No.87-1165, Hosanna Mandir Road, Nandyal Road, Revenue Colony, Kurnool, Andhra Pradesh 518002</a></li>
                                    <li><span>Phone:</span><a href="tel:9963276070">+(91) 9963276070</a></li>
                                    <li><span>Email:</span><a href="mailto:info@example.com">reddyg.spurthi@gmail.com</a></li>
                                    <li><span>Website:</span><a href="/">www.sunshineadvancedeyecare.com</a></li>
                                </ul>
                                <ul className="social-link clearfix">
                                    <li><a href="https://www.facebook.com/profile.php?id=100091975440305&mibextid=ZbWKwL"><i className="fab fa-facebook-f"></i></a></li>
                                    <li><a href="https://instagram.com/sunshineadvancedeyecare?igshid=MzRlODBiNWFlZA=="><i className="fab fa-instagram"></i></a></li>
                                    <li style={{display: 'none'}}><a href="/"><i className="fab fa-twitter"></i></a></li>
                                    <li style={{display: 'none'}}><a href="/"><i className="fab fa-google-plus-g"></i></a></li>
                                </ul>
                            </div>
                            {/* <div className="skills-box">
                                <div className="text">
                                    <h3>My Skills</h3>
                                    <p></p>
                                </div>
                                <div className="progress-box">
                                    <div className="progress-box p_relative d_block mb_25">
                                        <h5>Empathy</h5>
                                        <div className="bar">
                                            <div className="bar-inner count-bar" data-percent="85%"></div>
                                            <div className="count-text">85%</div>
                                        </div>
                                    </div>
                                    <div className="progress-box p_relative d_block mb_25">
                                        <h5>Technique</h5>
                                        <div className="bar">
                                            <div className="bar-inner count-bar" data-percent="90%"></div>
                                            <div className="count-text">90%</div>
                                        </div>
                                    </div>
                                    <div className="progress-box p_relative d_block">
                                        <h5>Operation</h5>
                                        <div className="bar">
                                            <div className="bar-inner count-bar" data-percent="75%"></div>
                                            <div className="count-text">75%</div>
                                        </div>
                                    </div>
                                </div>
                            </div> */}
                            <div className="contact-box" style={{display: 'none'}}>
                                <div className="text">
                                    <h3>Contact Me</h3>
                                </div>
                                <div className="form-inner">
                                    <form action="team-details.html" method="post" id="myForm">
                                        <div className="row clearfix">
                                            <div className="col-lg-6 col-md-6 col-sm-12 column">
                                                <div className="form-group">
                                                    <input type="text" name="name" placeholder="Your name" />
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-6 col-sm-12 column">
                                                <div className="form-group">
                                                    <input type="email" name="email" placeholder="Your Email" />
                                                </div>
                                            </div>
                                            <div className="col-lg-12 col-md-12 col-sm-12 column">
                                                <div className="form-group">
                                                    <input type="text" name="phone" placeholder="Phone" />
                                                </div>
                                            </div>
                                            <div className="col-lg-12 col-md-12 col-sm-12 column">
                                                <div className="form-group">
                                                    <textarea name="message" placeholder="Message"></textarea>
                                                </div>
                                            </div>
                                            <div className="col-lg-12 col-md-12 col-sm-12 column">
                                                <div className="form-group message-btn">
                                                    <button type="submit" className="theme-btn btn-one">Send Message</button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        
        {/* <Subscribe /> */}

        <Footer />
        <ScrollToTopButton />
      </div>
    </div>
    );
  }
  
  export default DoctorProfile;